import React, { useState, useEffect } from 'react';
import debounce from 'lodash.debounce';
import classNames from 'classnames';
import { HelperTextProps } from './HelperTextInterface';

import './_HelperText.scss';

const HelperText: React.FC<HelperTextProps> = ({ helperText, showHelperText, helperContent }) => {
  const [outerWidth, setouterWidth] = useState<number>(window.outerWidth);

  useEffect(() => {
    const changeouterWidth = debounce(() => {
      setouterWidth(window.outerWidth);
    }, 100);

    window.addEventListener('resize', changeouterWidth);

    return () => window.removeEventListener('resize', changeouterWidth);
  }, []);

  const positionLeft = outerWidth < 467 ? '-600%' : outerWidth < 1275 ? '-1000%' : '215%';
  const arrowClass = classNames('helper-text__arrow', {
    'helper-text__arrow--flip': outerWidth < 1275,
  });

  return (
    <div className={`helper-text ${showHelperText ? 'helper-text--show' : ''}`} style={{ left: positionLeft }}>
      <h3 className="helper-text__header">Help</h3>
      {helperText && <p className="helper-text__description">{helperText}</p>}
      {helperContent && <p className="helper-text__content">{helperContent}</p>}
      <span className={arrowClass} />
    </div>
  );
};

export default HelperText;
